module.exports = __webpack_public_path__ + "static/media/Social_service.d623bfe8.jpeg";